import React from 'react';
import client1 from "../assets/client1.jpg"
import client2 from "../assets/client2.jpg"
import client3 from "../assets/client3.jpg"
import client4 from "../assets/client4.jpg"
import client5 from "../assets/client5.jpg"
import client6 from "../assets/client6.jpg"

const Clients = () => {
  const clients = [
  { name: "iics", logo: client1 },
  { name: "i3t", logo: client2 },
  { name: "nature", logo: client3 },
  { name: "abunayyan", logo: client4 },
  { name: "eaton", logo: client5 },
  { name: "zpop", logo: client6 },
  { name: "Client 7", logo: client1 },
  { name: "Client 8", logo: client2 },
];

  return (
    <section id="clients" className="py-16 px-6 bg-gray-100">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Our Valued Clients</h2>
          <p className="text-xl text-gray-600">We've had the privilege of working with amazing companies</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {clients.map((client, index) => (
            <div key={index} className="bg-netbernet-white p-6 rounded-lg shadow-md flex items-center justify-center h-24">
              <img 
                src={client.logo} 
                alt={client.name} 
                className="max-h-12 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;